/**
* description:
* All Vue.js Custom Filters
*
* data : 2017-08-25
*/

import Vue from 'vue';
import moment from 'moment';
/*
* Filter: HHMMSS
*
* zamienia sekundy na format HH:MM:SS
*/
Vue.filter('HHMMSS', (totalSeconds) => {
  let _totalSeconds = totalSeconds;
  if (_totalSeconds === 0) return '---';
  let hours = Math.floor(_totalSeconds / 3600);
  if (hours < 10) hours = `0${hours}`;
  _totalSeconds %= 3600;
  let minutes = Math.floor(_totalSeconds / 60);
  if (minutes < 10) minutes = `0${minutes}`;
  let seconds = _totalSeconds % 60;
  if (seconds < 10) seconds = `0${seconds}`;
  return `${hours}:${minutes}:${seconds}`;
});

Vue.filter('timeWithoutSeconds', (value) => {
  const explodedValue = value.split(':');
  const hours = explodedValue[0];
  const minutes = explodedValue[1];
  return `${hours}:${minutes}`;
});

/*
* Filter: displayNumber
*
* Metoda wyświetla 9-cyfrowy numer, poprzez dodanie spacji co 3 cyfry.
*/
Vue.filter('displayNumber', number => ((number > 0) ? `${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6, 9)}` : '---'));

/*
* Filter: formatBytes
*
* zamienia bity na odpowiednie wartości w KB, MB etc
* source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
*/
Vue.filter('formatBytes', (bytes) => {
  const _bytes = Number(bytes);
  if (_bytes === 0) return '---';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(_bytes) / Math.log(k));
  return `${parseFloat((_bytes / (k ** i)).toFixed(2))} ${sizes[i]}`;
});

/*
* Filter: ivrMenuActionTypes
*
* zamienia akcje z ivr menu na pełne nazwy
*/
Vue.filter('ivrMenuActionTypes', (action) => {
  const possibleIvrMenuActionsMap = {
    FA: 'FA - kierowanie do Agentów/Placówek',
    SUB: 'SUB - submenu',
    EX: 'EX - akcje specjalne',
    ANN: 'ANN - komunikat głosowy',
    ACD: 'ACD - przekierowanie po numerze kierunkowym (prefiks)',
    PACD: 'PACD - przekierowanie po kodach pocztowych',
    PG: 'PG - przekierowanie na pocztę głosową',
    CMB: 'CMB - życzenie oddzwonienia',
  };

  return possibleIvrMenuActionsMap[action];
});

Vue.filter('polishDateFormat', value => moment(value).format('DD.MM.YYYY'));
Vue.filter('polishDateTimeFormat', value => moment(value).format('DD.MM.YYYY HH:mm:ss'));
Vue.filter('extractTimeFromTimestamp', timestamp => (timestamp ? (timestamp.split('.')[0]).split('+')[0] : null));
